import { Box } from "@mui/material";
import React from "react";
import Footer from "../../components/common/footer";
import BackNavbar from "../../components/common/backNavbar";

const ApplicationLayout = ({ children }) => {
  return (
    <Box>
      <BackNavbar />
      {children}
      <Footer />
    </Box>
  );
};

export default ApplicationLayout;
